import './App.css';
import Footer from './footer/Footer';
import Head from './head/Head';
import Card from './body/cards/Card';

function Web() {
  return (
    <div className='App1'>
    <Head/>
    <Card/>
    <Footer/>
   </div>
  );
}

export default Web;